import INFTCollections from '../../models/INFTCollections'
import AVAXBrosNFTCard from '../../nftFormats/AVAXBrosNFT/Card/AVAXBrosNFTCard'
import AVAXBrosNFTDetail from '../../nftFormats/AVAXBrosNFT/Detail/AVAXBrosNFTDetail'
import AVAXBrosNFTActivityDetail from '../../nftFormats/AVAXBrosNFT/Activity/AVAXBrosNFTActivityDetail'
import AVAXBrosNFTLogo from '../../../../assets/nft-logo/AVAXBrosNFT.jpg'

export const AVAXBrosNFTData: INFTCollections[] = [
  {
    id: 'AVAXBrosNFT',
    tokenAddress: '0x4dB152A1ffb71918EAF10c0BAebD5dA535a51932',
    name: 'Bros',
    cardFormat: AVAXBrosNFTCard,
    detailFormat: AVAXBrosNFTDetail,
    activityFormat: AVAXBrosNFTActivityDetail,
    category: 1,
    creatorAddress: '0x7344660044360D54b6f8E9a652C950dE816F2Ce2',
    logo: AVAXBrosNFTLogo,
    website: 'https://avaxbros.com/',
    twitter: 'avaxbros',
    telegram: 'https://t.me/avaxbros',
    discord: 'https://discord.com/invite/45cFWveh'
  }
]

export const AVAXBrosNFTCategoryData = {
  [AVAXBrosNFTData[0].tokenAddress.toLowerCase()]: AVAXBrosNFTData[0].category
}
